import { FormContext } from '@bnnvara/forms/src/new_components/BaseForm/FormContext';
import { Select } from '@bnnvara/forms/src/new_components/inputs/Select/Select';
import { TextInput } from '@bnnvara/forms/src/new_components/inputs/TextInput/TextInput';
import { SubmitButton } from '@bnnvara/forms/src/new_components/SubmitButton/SubmitButton';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import * as S from './styled';

export const PersonalDataStep = ({ onSubmit }) => {
  const { partialValidate } = useContext(FormContext);

  async function onClick(event) {
    event.preventDefault();

    const validationResult = await partialValidate([
      'membership',
      'initials',
      'firstName',
      'nameAffix',
      'lastName',
      'gender',
      'dateOfBirth',
    ]);

    const isValid = validationResult.every((field) => field.isValid);

    if (isValid) {
      onSubmit();
    }
  }

  return (
    <>
      <S.Grid fullWidth>
        <GridItem columnStartSm="1" columnEndSm="span 12">
          <TextInput
            fullWidth
            showIsRequired
            type="text"
            name="initials"
            label="Voorletter(s)"
            validation="required"
            autoComplete="nope"
          />
        </GridItem>
        <GridItem columnStartSm="1" columnEndSm="span 12">
          <TextInput
            fullWidth
            showIsRequired
            type="text"
            name="firstName"
            label="Voornaam"
            validation="required"
            autoComplete="given-name"
          />
        </GridItem>
        <GridItem columnEndSm="span 5" columnEndMd="span 4">
          <TextInput
            fullWidth
            type="text"
            name="nameAffix"
            value=""
            label="Tussenvoegsel"
            autoComplete="additional-name"
          />
        </GridItem>
        <GridItem
          columnStartSm="6"
          columnEndSm="span 7"
          columnStartMd="5"
          columnEndMd="span 8"
        >
          <TextInput
            fullWidth
            showIsRequired
            type="text"
            name="lastName"
            label="Achternaam"
            validation="required"
            autoComplete="family-name"
          />
        </GridItem>
        <GridItem columnEndSm="span 5" columnEndMd="span 4">
          <Select
            options={[
              { value: '', text: '' },
              { value: 'male', text: 'Man' },
              { value: 'female', text: 'Vrouw' },
              { value: 'other', text: 'X' },
            ]}
            label="Geslacht"
            name="gender"
            validation="required|"
            showIsRequired
          />
        </GridItem>
        <GridItem
          columnStartSm="6"
          columnEndSm="span 7"
          columnStartMd="5"
          columnEndMd="span 8"
        >
          <TextInput
            fullWidth
            showIsRequired
            type="text"
            name="dateOfBirth"
            label="Geboortedatum"
            placeholder="dd-mm-yyyy"
            validation="required|dateOfBirth"
          />
        </GridItem>
      </S.Grid>

      <SubmitButton
        title="Doorgaan naar contactgegevens"
        fullWidth
        onClick={onClick}
      />
    </>
  );
};

PersonalDataStep.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};
